import { lazy } from 'react'
import SuspenseSkeleton from '../../../../components/containers/SuspenseSkeleton';
import SoapVisor from './SoapVisor';
import RouterBase from '../../../../components/navigation/RouterBase';
import { URLAPP } from '../../../../config';

const SoapAdmin = lazy(() => import('./SoapAdmin'));

export default function SoapRouter() {
    return (
        <RouterBase
            items={[
                {
                    component: <SoapVisor />,
                    path: "documento/:apiId",
                    fullPath: URLAPP.apidocSoapDoc
                },
                {
                    component: <SuspenseSkeleton itemLazy={<SoapAdmin />} />,
                    path: "administracion",
                    fullPath: URLAPP.apidocSoapAdmin
                }
            ]}
        />
    )
}
